import React, { memo, RefObject, useEffect, useRef, useState } from 'react'
import { ISelectWithSearch } from './SelectWithSearch.types'
import { Item, ItemsList, SearchInput, SelectWrapper } from './SelectWithSearch.styles'
import { Loader } from 'utils/Loader/Loader'
import { useOnClickOutside } from 'utils/customHooks/useOnClickOutside'
import { ReactComponent as ArrowDown } from 'assets/icons/downArrow.svg'

const SelectWithSearchComponent: React.FC<ISelectWithSearch> = ({
  itemsArr,
  onSelect,
  isLoading,
  defaultValue,
  additionalTrigger,
  secondValueIsDefault,
  dontRenewOnListChange,
  minWidth,
  minHeight,
  width,
  noMargin,
}) => {
  const [isOpened, setIsOpened] = useState(false)
  const [selected, setSelected] = useState(itemsArr?.length ? itemsArr[0] : '')
  const [searchValue, setSearchValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)
  const selectRef = useRef<HTMLDivElement>(null)
  const toggleIsOpened = () => {
    setIsOpened(prev => !prev)
  }
  useEffect(() => {
    if (defaultValue) {
      setSelected(defaultValue)
      onSelect(defaultValue)
    } else {
      if (!dontRenewOnListChange) {
        if (itemsArr?.length && itemsArr.length > 1) {
          setSelected(itemsArr[secondValueIsDefault ? 1 : 0])
          onSelect(itemsArr[secondValueIsDefault ? 1 : 0])
        } else if (itemsArr?.length) {
          setSelected(itemsArr[0])
          onSelect(itemsArr[0])
        } else {
          setSelected('')
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsArr])
  useEffect(() => {
    if (isOpened) {
      inputRef?.current?.focus()
    }
  }, [isOpened])
  useEffect(() => {
    if (additionalTrigger && additionalTrigger !== selected) {
      setSelected(additionalTrigger)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalTrigger])
  useOnClickOutside(selectRef as RefObject<HTMLDivElement>, () => setIsOpened(false))
  return (
    <SelectWrapper ref={selectRef} minWidth={minWidth} minHeight={minHeight} noMargin={noMargin}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Item
            style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
            onClick={toggleIsOpened}
            minHeight={minHeight}
            width={width}
            isZeroItem={true}
          >
            {selected}
          </Item>
          {isOpened && (
            <ItemsList width={width}>
              <SearchInput
                type="text"
                ref={inputRef}
                placeholder="Search"
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
                width={width}
              />
              {!itemsArr?.length && <div>No data</div>}
              {defaultValue && (
                <Item
                  minHeight={minHeight}
                  width={width}
                  onClick={() => {
                    setSelected(defaultValue)
                    onSelect(defaultValue)
                    toggleIsOpened()
                  }}
                >
                  {defaultValue}
                </Item>
              )}
              {[...itemsArr]
                .filter(item => {
                  if (searchValue && item !== null) {
                    if (item.toLowerCase().match(searchValue.toLowerCase())) {
                      return true
                    }
                    return false
                  } else {
                    return true
                  }
                })
                .sort((prev, next) => {
                  if (next?.toUpperCase() === searchValue?.toUpperCase()) return 1
                  if (prev?.toUpperCase() === searchValue?.toUpperCase()) return -1
                  return 0
                })
                .slice(0, 20)
                .map(item => (
                  <Item
                    width={width}
                    minHeight={minHeight}
                    onClick={() => {
                      setSelected(item)
                      onSelect(item)
                      toggleIsOpened()
                    }}
                  >
                    {item}
                  </Item>
                ))}
            </ItemsList>
          )}
        </>
      )}
      <ArrowDown onClick={toggleIsOpened} />
    </SelectWrapper>
  )
}

function areEqual(prevProps: ISelectWithSearch, nextProps: ISelectWithSearch): boolean {
  return Object.entries(nextProps).toString() === Object.entries(prevProps).toString()
}
export const SelectWithSearch = memo(SelectWithSearchComponent, areEqual)
